require('./mortgageRequestEstates.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { includes, chain, filter, union } = require('lodash');

// @ utilities
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');

// @ track processes
const { PROC_ADD_ESTATES_DATA } = require('constants/mortgageRequestProcesses');

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const infoPageComponent = require('./infoPage');
const Modal = require('./modal');
const { text } = require('components/mortgageRequest/mortgageRequestEstates/initialValues');

// @ constants
const { LivingPlace } = require('./livingPlace');
const { AnotherEstates } = require('./anotherEstates');
const { NS_RESULT, NS_UPLOADED_OR_REQUESTED } = require('constants/mortgageRequestPanelStates');
const { ESTATES_TYPE_ABBREVIATION } = require('constants/mortgageRequestEstates');

// @ actions
const { saveEstates, getEstatesData, resetDeleteEstate } = require('actions/mortgageRequest/mortgageRequestEstates');
const { requestSelectsData, resetLocationData } = require('actions/mortgageRequest/mortgageRequestLocationData');

class MortgageRequestEstates extends React.Component {
    constructor(props) {
        super(props);

        this.buildData = {
            anotherEstates: () => { },
            livingPlace: () => { },
        };

        this.infoPage = false;
        this.addressData = {};
        this.anotherEstatesData = {};

        this.canEdit = false;
        this.wantEdit = false;
        this.infoSetted = false;
        this.selectDataActionRequested = false;
        this.estatesDataSetted = false;
        this.selectsDataRequested = false;
        this.hasNSResult = false;

        this.handleOnSave = this.handleOnSave.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.handleEditForm = this.handleEditForm.bind(this);
        this.handleCancelAddEstates = this.handleCancelAddEstates.bind(this);
    }

    componentDidMount() {
        const { requestSelectsDataAction, getEstatesDataAction } = this.props;
        recordProcess(PROC_START, PROC_ADD_ESTATES_DATA);
        getEstatesDataAction();
        requestSelectsDataAction();
    }

    componentWillUnmount() {
        this.props.resetLocationDataAction();
    }

    setInfo() {
        const { immMortgageState, immInmueblesState } = this.props;
        const currentState = immMortgageState.get('estado');

        this.hasNSResult = includes(NS_RESULT, currentState);
        this.canEdit = !includes(NS_UPLOADED_OR_REQUESTED, currentState) && !this.hasNSResult;

        const data = immInmueblesState.get('list').toJS();

        this.addressData = chain(data).find(estate => estate.propertyType === ESTATES_TYPE_ABBREVIATION.VIVIENDA).value();

        this.anotherEstatesData = {
            garages: filter(data, estate => estate.propertyType === ESTATES_TYPE_ABBREVIATION.GARAJE),
            storageRooms: filter(data, estate => estate.propertyType === ESTATES_TYPE_ABBREVIATION.TRASTERO)
        };

        this.infoPage = this.addressData ? infoPageComponent(this.addressData, this.anotherEstatesData, this.handleEditForm, this.hasNSResult) : '';

        this.infoSetted = true;
        this.estatesDataSetted = true;
    }

    buildFormData() {
        const textValue = text();
        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <h2>{textValue.TITLE}</h2>
                            <p className="mortgage-request-estates-view__title-p">{textValue.SUMMARY}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <Accordion onClick={() => { }} isExpanded>
                                <AccordionHeader name="AccordionHeader" isRightArrowPosition>
                                    <h3>{textValue.LIVING_PLACE.SUBTITLE}</h3>
                                </AccordionHeader>
                                <AccordionBody name="AccordionBody">
                                    <LivingPlace
                                        onBuildData={buildData => this.buildData.livingPlace = buildData}
                                        addressData={this.addressData}
                                    />
                                </AccordionBody>
                            </Accordion>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <Accordion onClick={() => { }} isExpanded>
                                <AccordionHeader name="AccordionHeader" isRightArrowPosition>
                                    <h3>{textValue.ANOTHER_ESTATES.TITLE}</h3>
                                </AccordionHeader>
                                <AccordionBody name="AccordionBody">
                                    <AnotherEstates
                                        onBuildData={buildData => this.buildData.anotherEstates = buildData}
                                        anotherEstatesData={this.anotherEstatesData}
                                        livingPlaceAddressData={this.addressData}
                                    />
                                </AccordionBody>
                            </Accordion>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-xs-12">
                        <div className="mortgage-request-estates-view__link-container pull-left">
                            <a
                                href="#"
                                className="ok-link"
                                onClick={this.handleCancelAddEstates}
                            >
                                {textValue.LABEL.BACK}
                            </a>
                        </div>
                        <div className="pull-right">
                            <OKButton
                                id="mortgage-request-estates-view__save-button"
                                modifier="primary"
                                onClick={this.handleOnSave}
                                loading={this.props.immEstatesState.get('isFetching')}
                                disabled={this.props.immEstatesState.get('isFetching')}
                                children={textValue.LABEL.SAVE}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleCancelAddEstates(evt) {
        evt.preventDefault();
        recordProcess(PROC_ADD_ESTATES_DATA, PROC_CANCEL);
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleEditForm() {
        this.wantEdit = true;
        this.forceUpdate();
    }

    handleOnCloseModal() {
        this.wantEdit = false;
        this.forceUpdate();
    }

    handleOnSave() {
        const livingPlaceData = this.buildData.livingPlace();
        const anothersEstatesData = this.buildData.anotherEstates();

        if (livingPlaceData) {
            let data = [livingPlaceData];

            livingPlaceData.garages = '0';
            livingPlaceData.storageRooms = '0';

            if (anothersEstatesData) {
                livingPlaceData.garages = anothersEstatesData.ammounts.garage.toString();
                livingPlaceData.storageRooms = anothersEstatesData.ammounts.storageRoom.toString();
                data = data.concat(union(anothersEstatesData.storageRoomData, anothersEstatesData.garageData));
            }

            this.props.saveEstatesAction(data, this.props.history);
        } else {
            this.forceUpdate();
        }
    }

    render() {
        const {
            immInmueblesState,
            immEstatesState,
            immLocationDataState,
            immMortgageState,
            resetDeleteEstateAction
        } = this.props;

        if (immInmueblesState.get('estateDeleted')) {
            setTimeout(() => {
                this.setInfo();
                resetDeleteEstateAction();
            }, 100);
        }

        if (immInmueblesState.get('isFetching') ||
            !immInmueblesState.get('hasBeenFetched') ||
            immEstatesState.get('dataSaved') ||
            !immMortgageState.get('estado') ||
            !immLocationDataState.get('allEditSelectsLoaded')
        ) {
            return <LoadingSection />;
        }

        let formData = '';
        let modal = '';
        let infoPage = '';

        if (immInmueblesState.get('list').isEmpty() && immInmueblesState.get('hasBeenFetched')) {
            formData = this.buildFormData();
        } else {
            this.infoSetted || this.setInfo();

            infoPage = this.infoPage;

            if (this.wantEdit) {
                if (!this.canEdit) {
                    modal = Modal(this.handleOnCloseModal);
                } else {
                    infoPage = '';
                    if (immInmueblesState.get('hasBeenFetched')) {
                        formData = this.buildFormData();
                    } else {
                        return <LoadingSection />;
                    }
                }
            }
        }

        return (
            <div className="mortgage-request-estates">
                <ContentBox>
                    {infoPage}
                    {modal}
                    {formData}
                </ContentBox>
            </div>
        )
    }
}

MortgageRequestEstates.propTypes = {
    history: PropTypes.object.isRequired,
    immInmueblesState: PropTypes.object,
    immEstatesState: PropTypes.object,
    immMortgageState: PropTypes.object,
    immLocationDataState: PropTypes.object,
    saveEstatesAction: PropTypes.func,
    getEstatesDataAction: PropTypes.func,
    requestSelectsDataAction: PropTypes.func,
    resetLocationDataAction: PropTypes.func,
    resetDeleteEstateAction: PropTypes.func,
}

module.exports.constructor = MortgageRequestEstates;

module.exports.MortgageRequestEstates = connect(state => ({
    immInmueblesState: state.mortgageRequestInmuebles,
    immEstatesState: state.mortgageRequestEstates,
    immMortgageState: state.mortgageRequestState,
    immLocationDataState: state.mortgageRequestLocationData,
}), {
    saveEstatesAction: saveEstates,
    getEstatesDataAction: getEstatesData,
    requestSelectsDataAction: requestSelectsData,
    resetLocationDataAction: resetLocationData,
    resetDeleteEstateAction: resetDeleteEstate
})(withRouter(MortgageRequestEstates));
